import { useQuery } from '@tanstack/react-query'
import { clikArtService } from '@/api/services/clikart.service'
import { queryKeys } from '@/api/query-keys'
import { nextClikArtPlacedIdsPollDelay } from '@/lib/clikart/clikart-placed-ids-poll'

/**
 * The book's placed ClikArt from the backend's cache — cheap to read (it never starts a scan), so
 * it is read as soon as the editor is ready. While the backend's scan is running it is read again
 * on a growing delay, for a bounded time (`nextClikArtPlacedIdsPollDelay`); the trigger's own
 * reply (`useClikArtPlacedIdsScan`) is written into this same query, so the polling picks up from
 * it. Failures are not retried and not shown: without it the gallery keeps the catalog's flag.
 */
export function useClikArtPlacedIdsQuery(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.clikArt.placedIds(),
    queryFn: () => clikArtService.getPlacedClikArtIds(),
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    refetchInterval: (query) =>
      nextClikArtPlacedIdsPollDelay(query.state.data?.isScanning, query.state.dataUpdateCount),
  })
}
